export default __webpack_public_path__ + "static/media/sanitizer6.c37f8de3.jpg";